/* Paw & Cove / NewsBreak analytics-only compatibility layer.
 * Does not modify checkout/app files, app methods, forms, price, plans, or cart writes.
 * Official NewsBreak app remains enabled. OuYify checkout owns checkout/payment events.
 */
(() => {
  'use strict';
  if (window.__pawNewsBreakObserver || window.Shopify?.shop !== 't7jqd4-ie.myshopify.com') return;
  const productPath = '/products/kelveth-paw-balm';
  if (![productPath, '/cart'].includes(location.pathname.replace(/\/$/, ''))) return;
  const state = window.__pawNewsBreakObserver = {version: 1, added: 0, suppressedCheckout: 0};
  const storageKey = 'paw-newsbreak-pending-add-v1';
  const allowed = () => Boolean(window.Shopify?.customerPrivacy?.marketingAllowed?.() && window.Shopify?.customerPrivacy?.saleOfDataAllowed?.());
  const meta = line => {try {return JSON.parse(line.properties?.__kaching_bundles || 'null');} catch {return null;}};
  let baseline = null, pending = null, checking = false, timer = null;
  let checkoutClick = false, filteredPixel;

  // Filter only the duplicate NewsBreak call during a known checkout-button click.
  // No checkout handler is wrapped, replaced, cancelled, or delayed.
  function filterPixel() {
    const original = window.nbpix;
    if (typeof original !== 'function' || original === filteredPixel) return;
    filteredPixel = new Proxy(original, {apply(target, receiver, args) {
      if (checkoutClick && args[0] === 'event' && args[1] === 'initiate_checkout') {
        state.suppressedCheckout++;
        return;
      }
      return Reflect.apply(target, receiver, args);
    }});
    window.nbpix = filteredPixel;
  }
  window.addEventListener('click', event => {
    if (!event.target?.closest?.('#yx_checkout,#yx_cart_drawer_checkout,#yx_cart_checkout,#yx_paypal_checkout,#yx_paypal_checkout_drawer,#yx_kl_checkout')) return;
    checkoutClick = true;
    filterPixel();
    setTimeout(() => {checkoutClick = false;}, 0);
  }, true);

  const read = async () => {
    const response = await fetch('/cart.js', {cache: 'no-store'});
    if (!response.ok) throw new Error('Cart read unavailable');
    return response.json();
  };
  function save() {try {sessionStorage.setItem(storageKey, JSON.stringify(pending));} catch {}}
  function drop() {pending = null;try {sessionStorage.removeItem(storageKey);} catch {}}
  function schedule() {clearTimeout(timer);timer = setTimeout(verify, 1000);}
  async function verify() {
    if (checking || !pending) return;
    if (!allowed() || Date.now() - pending.time > 20000) {drop();return;}
    checking = true;
    try {
      const cart = await read();
      let cents = 0;
      for (const [variant, expected] of Object.entries(pending.expected)) {
        const lines = cart.items.filter(i => String(i.variant_id) === variant && meta(i)?.deal === pending.deal);
        const added = lines.map(i => ({line: i, quantity: Math.max(0, i.quantity - (pending.before[i.key] || 0))}));
        if (added.reduce((sum, x) => sum + x.quantity, 0) !== expected) return;
        cents += added.reduce((sum, x) => sum + x.line.final_line_price * x.quantity / x.line.quantity, 0);
      }
      if (!Number.isFinite(cents) || cents <= 0 || typeof window.nbpix?.process !== 'function') return;
      const value = Math.round(cents) / 100;
      // Only a verified cart mutation can produce this event. Zero-priced gifts
      // are included in the amount but never reported as additional conversions.
      window.nbpix('event', 'add_to_cart', {nb_value: value});
      state.added++;
      state.lastAddValue = value;
      baseline = cart;
      drop();
    } catch { /* Tracking never changes purchase outcomes. */ }
    finally {checking = false;if (pending) schedule();}
  }
  function start() {
    if (!allowed()) return;
    try {pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');} catch {}
    if (pending) schedule();
    read().then(cart => {baseline = cart;}).catch(() => {});
  }
  document.addEventListener('click', event => {
    if (location.pathname.replace(/\/$/, '') !== productPath || !allowed() || !baseline) return;
    const button = event.target?.closest?.('[data-native-purchase] button[name="add"],[id^="SectionAtcBtn-"]');
    if (!button || button.disabled || pending) return;
    const block = document.querySelector('kaching-bundles-block');
    const items = typeof block?.items === 'function' ? block.items() : null;
    if (!items?.length || !items.some(i => String(i.id) === '48276223852695')) return;
    const deal = meta(items[0])?.deal;
    if (deal !== 'R4du') return;
    const expected = {};
    for (const item of items) expected[item.id] = (expected[item.id] || 0) + Number(item.quantity);
    if (!Object.values(expected).every(q => Number.isInteger(q) && q > 0)) return;
    const before = {};
    for (const line of baseline.items) if (meta(line)?.deal === deal) before[line.key] = line.quantity;
    pending = {actionId: crypto.randomUUID(), time: Date.now(), expected, before, deal};
    save();schedule();
  }, true);
  document.addEventListener('visitorConsentCollected', () => {if (allowed()) start();else drop();});
  if (window.Shopify?.customerPrivacy) start();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => {if (!error) start();});
})();
